import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-how-to-ambulancia',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './how-to-ambulancia.component.html',
  styleUrl: './how-to-ambulancia.component.css'
})
export class HowToAmbulanciaComponent {
  services : any | [] = [
    {
      name: 'Médico a Domicilio',
      imagen: 'medicoDomicilio.svg',
      descripcion: 'Valoración médica integral por parte de un médico con experiencia.'
    },
    {
      name: 'Traslado Programado',
      imagen: 'trasladdoProgramado.svg',
      descripcion: 'Traslado de paciente de un lugar a otro con asistencia médica, hacia hospitales y clínicas.'
    },
    {
     name: 'Traslado Prehospitalario',
      imagen: 'trasladoHospitalario.svg',
      descripcion: 'Movilización de emergencia desde el lugar del incidente/accidente hacia hospitales y clínicas.'
    }
    ]


}
